"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: miimosa/leads/v1/output.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.OutputValue = exports.outputNameToJSON = exports.outputNameFromJSON = exports.OutputName = void 0;
/* eslint-disable */
exports.OutputName = {
    OUTPUT_NAME_UNSPECIFIED: "OUTPUT_NAME_UNSPECIFIED",
    OUTPUT_NAME_PSFP_INFORMED: "OUTPUT_NAME_PSFP_INFORMED",
    OUTPUT_NAME_PSFP_NET_WEALTH: "OUTPUT_NAME_PSFP_NET_WEALTH",
    UNRECOGNIZED: "UNRECOGNIZED",
};
function outputNameFromJSON(object) {
    switch (object) {
        case 0:
        case "OUTPUT_NAME_UNSPECIFIED":
            return exports.OutputName.OUTPUT_NAME_UNSPECIFIED;
        case 300:
        case "OUTPUT_NAME_PSFP_INFORMED":
            return exports.OutputName.OUTPUT_NAME_PSFP_INFORMED;
        case 301:
        case "OUTPUT_NAME_PSFP_NET_WEALTH":
            return exports.OutputName.OUTPUT_NAME_PSFP_NET_WEALTH;
        case -1:
        case "UNRECOGNIZED":
        default:
            return exports.OutputName.UNRECOGNIZED;
    }
}
exports.outputNameFromJSON = outputNameFromJSON;
function outputNameToJSON(object) {
    switch (object) {
        case exports.OutputName.OUTPUT_NAME_UNSPECIFIED:
            return "OUTPUT_NAME_UNSPECIFIED";
        case exports.OutputName.OUTPUT_NAME_PSFP_INFORMED:
            return "OUTPUT_NAME_PSFP_INFORMED";
        case exports.OutputName.OUTPUT_NAME_PSFP_NET_WEALTH:
            return "OUTPUT_NAME_PSFP_NET_WEALTH";
        case exports.OutputName.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.outputNameToJSON = outputNameToJSON;
function createBaseOutputValue() {
    return { name: exports.OutputName.OUTPUT_NAME_UNSPECIFIED, number: undefined, str: undefined, boolean: undefined };
}
exports.OutputValue = {
    fromJSON: function (object) {
        return {
            name: isSet(object.name) ? outputNameFromJSON(object.name) : exports.OutputName.OUTPUT_NAME_UNSPECIFIED,
            number: isSet(object.number) ? globalThis.Number(object.number) : undefined,
            str: isSet(object.str) ? globalThis.String(object.str) : undefined,
            boolean: isSet(object.boolean) ? globalThis.Boolean(object.boolean) : undefined,
        };
    },
    toJSON: function (message) {
        var obj = {};
        if (message.name !== exports.OutputName.OUTPUT_NAME_UNSPECIFIED) {
            obj.name = outputNameToJSON(message.name);
        }
        if (message.number !== undefined) {
            obj.number = Math.round(message.number);
        }
        if (message.str !== undefined) {
            obj.str = message.str;
        }
        if (message.boolean !== undefined) {
            obj.boolean = message.boolean;
        }
        return obj;
    },
    create: function (base) {
        return exports.OutputValue.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial: function (object) {
        var _a, _b, _c, _d;
        var message = createBaseOutputValue();
        message.name = (_a = object.name) !== null && _a !== void 0 ? _a : exports.OutputName.OUTPUT_NAME_UNSPECIFIED;
        message.number = (_b = object.number) !== null && _b !== void 0 ? _b : undefined;
        message.str = (_c = object.str) !== null && _c !== void 0 ? _c : undefined;
        message.boolean = (_d = object.boolean) !== null && _d !== void 0 ? _d : undefined;
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=output.js.map